import { javantApi } from "../constants";

export const DownloadDetailPageService = {
    getDataByIdVersion(type, id, version){
        return javantApi.get(`content/app/apps/detail/${id}/version/${version}`); 
    },
    getDataByIdVersionIronsource(type, id, version){
        return javantApi.get(`content/app/apps/detail/${id}/version/${version}/ironsource`); 
    },
}